import CommonLayout, { CommonLayoutInstance } from '@/components/CommonLayout';
import { Space, Form, Input, Modal, Table, Button, Badge, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { getDeviceList } from '@/api/video';
import { WsFlvModal, WsFlvModalRef } from '../components';
// import { useSystem } from '@/hooks/useUserInfo';

const { Text } = Typography;

type ChannelModalRef = {
  show: (dataSource: any[], title: string) => void;
};

const ChannelModal = forwardRef<ChannelModalRef, { onPlay: (params: { channelId: string; deviceId: string }) => void }>(({ onPlay }, ref) => {
  const [open, setOpen] = useState<boolean>(false);
  const [title, setTitle] = useState<string>('');
  const [dataSource, setDataSource] = useState<any[]>([]);
  useImperativeHandle(ref, () => {
    return {
      show: (dataSource: any[], title: string) => {
        setTitle(title);
        setDataSource(dataSource);
        setOpen(true);
      },
    };
  });

  // const { systemData } = useSystem();

  return (
    <Modal
      open={open}
      onCancel={() => {
        setOpen(false);
      }}
      title={`${title}通道详情`}
      centered
      width={'80vw'}
      cancelText="关闭"
      footer={(_origin, { CancelBtn }) => <CancelBtn></CancelBtn>}
      // styles={{ content: { maxWidth: '1000px' } }}
      zIndex={99}
      destroyOnClose
    >
      <Table
        dataSource={dataSource}
        pagination={false}
        rowKey={'id'}
        bordered
        columns={[
          { dataIndex: 'channelId', title: '编号', width: 200 },
          { dataIndex: 'name', title: '名称', width: 200 },
          { dataIndex: 'status', title: '状态', width: 200 },
          { dataIndex: 'liveStatus', title: '拉流状态', width: 200, render: (v: string) => ({ 0: '空闲', 1: 'invite', 2: '播放' })[v] },
          { dataIndex: 'manufacturer', title: '厂商', width: 200 },
          { dataIndex: 'address', title: '地址', width: 200 },
          { dataIndex: 'registerWay', title: 'RegisterWay', width: 200 },
          { dataIndex: 'safetyWay', title: 'SafetyWay', width: 200 },
          { dataIndex: 'secrecy', title: 'Secrecy', width: 200 },
          { dataIndex: 'parental', title: 'Parental', width: 200 },
          { dataIndex: 'owner', title: 'Owner', width: 200 },
          { dataIndex: 'model', title: '型号', width: 200 },
          { dataIndex: 'civilCode', title: 'CivilCode', width: 200 },
          {
            dataIndex: 'operate',
            title: '操作',
            fixed: 'right',
            width: 120,
            render: (_value, record) => (
              <Button
                type="link"
                onClick={() => {
                  // 175.24.164.93:8080
                  // console.log(process.env.NODE_ENV);
                  onPlay(
                    { channelId: record.channelId, deviceId: record.deviceId },
                    // `${systemData.ipc_addr}/jessica/${record.deviceSn}/${record.channelId}.flv`,
                    // `${location.protocol.includes('s') ? 'wss' : 'ws'}://${process.env.NODE_ENV === 'development' ? '175.24.164.93' : location.host}:8080/jessica/${record.deviceSn}/${record.channelId}.flv`,
                  );
                }}
              >
                播放
              </Button>
            ),
          },
        ]}
        scroll={{ x: 'max-content', y: 600 }}
      ></Table>
    </Modal>
  );
});

const VideoDevice = () => {
  const CommonLayoutRef = useRef<CommonLayoutInstance<{ params: {}; model: {}; drawerParams: {}; drawerModel: {} }>>(null);
  const channelModalRef = useRef<ChannelModalRef>(null);
  const wsFlvModalRef = useRef<WsFlvModalRef>(null);

  const onPlay = (params: { channelId: string; deviceId: string }) => {
    wsFlvModalRef.current?.show(params);
  };
  return (
    <>
      <WsFlvModal ref={wsFlvModalRef}></WsFlvModal>
      <ChannelModal ref={channelModalRef} onPlay={onPlay}></ChannelModal>
      <CommonLayout
        ref={CommonLayoutRef}
        breadcrumb={{
          title: '设备管理',
          describe: '蜂鸟物联网平台提供流媒体服务，支持接入gb28181的ipc设备，并且支持设备管理、分屏展示、录像回放等功能。',
        }}
        isHideDrawer
        searchFormChildren={
          <Space>
            <Form.Item name="name">
              <Input placeholder="设备名称或者编号" allowClear></Input>
            </Form.Item>
          </Space>
        }
        columns={[
          {
            dataIndex: 'deviceSn',
            title: '设备编号',
            fixed: 'left',
          },
          {
            dataIndex: 'name',
            title: '设备名称',
            fixed: 'left',
          },
          {
            dataIndex: 'netAddr',
            title: '网络地址',
          },
          {
            dataIndex: 'channels',
            title: '通道数',
            render: (v) => v?.length || 0,
          },
          {
            dataIndex: 'status',
            title: '状态',

            render(value: string) {
              return (
                <>
                  <Badge
                    color={
                      {
                        在线: 'green',
                        离线: 'gray',
                        告警: 'red',
                        未激活: 'orange',
                      }[value] || 'gray'
                    }
                  />
                  <Text className="ml5">{value || '未知'}</Text>
                </>
              );
            },
          },
          {
            dataIndex: 'manufacturer',
            title: '厂商',
          },
          {
            dataIndex: 'lastKeepaliveAt',
            title: '最后保活时间',
            render: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            dataIndex: 'lastKeepaliveAt',
            title: '注册时间',
            render: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss'),
          },
          {
            dataIndex: 'model',
            title: '型号',
          },
          // {
          //   dataIndex: 'lon',
          //   title: '经度',
          // },
          // {
          //   dataIndex: 'lat',
          //   title: '维度',
          // },
        ]}
        ajaxJson={{
          get: {
            // @ts-ignore
            ajax: getDeviceList,
            isNotToSetValues: true,
          },
        }}
        isHideOperateDetailButton
        operationColumnProps={{ fixed: 'right' }}
        operateButtonList={[
          {
            name: '通道详情',
            ajaxKey: 'detail',
            filter: (record) => !record?.channels?.length,
            onClick: (record) => {
              // console.log(record);
              channelModalRef.current?.show(
                record.channels.map((item: any) => ({ ...item, deviceSn: record.deviceSn })),
                record.name,
              );
            },
          },
        ]}
      ></CommonLayout>
    </>
  );
};
export default VideoDevice;
